// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js?{"omit":1,"remove":true}!./node_modules/vue-style-loader!./node_modules/css-loader?sourceMap!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c5e71bd6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/pc/components/shared/NavFooter.vue
// module id = 509
// module chunks = 14